export const faqs = [
  ['Is this a physical product?', 'No. The Complete Injury Rehabilitation Bundle is a 100% digital product.'],
  [
    'Who is this system for?',
    'It is designed for fitness professionals, coaches, trainers and physically active adults looking for an organized exercise reference.',
  ],
  ['Do I need a gym?', 'No. Bonus 02 includes home-based options using bodyweight and simple equipment.'],
  ['Are sets and reps included?', 'Yes. Exercises include practical dosage such as sets, reps or time and rest periods.'],
  ['Are there different levels?', 'Yes. The system includes beginner, intermediate and advanced exercise options.'],
  ['Are complete routines included?', 'Yes. The system and bonuses include ready-to-follow exercise routines.'],
  ['How do I receive the product?', 'You receive digital access after purchase.'],
  ['Is it a subscription?', 'No. The $26.90 USD purchase is a one-time payment.'],
  [
    'Does this replace physical therapy or medical care?',
    'No. This is educational exercise material. For diagnosed injuries, recent surgery or specific restrictions, follow the guidance of your healthcare professional.',
  ],
] as const
